import { PRIVATE_HTTP as http } from '../http-common';

const getInspections = (pageNumber: number) => {
  return http().get(
    `/api/v4/complaints?inspectable=true&page_number=${pageNumber}`
  );
};

const getInspectionsAll = (pageNumber: number) => {
  return http().get(`/api/v4/complaints?page_number=${pageNumber}`);
};

const getInspection = (incident_id: number) => {
  return http().get(`/api/v4/complaints/${incident_id}/inspections/`);
};

const uploadInspectionPhoto = async (formData: FormData, incident_id) => {
  return http({ formData: true }).post(
    `/api/v4/complaints/${incident_id}/inspections/actions/validate-photo`,
    formData
  );
};

const finishInspection = (incident_id, body) => {
  return http().post(
    `/api/v4/complaints/${incident_id}/inspections/actions/finish`,
    body
  );
};

export {
  getInspections,
  getInspection,
  getInspectionsAll,
  uploadInspectionPhoto,
  finishInspection,
};
